var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ppv2-flex ppv2-items-center ppv2-px-4 ppv2-py-2.5",staticStyle:{"background-color":"#0c1322","border-bottom":"1px solid #1e293b"}},[_c('TrafficLights'),_vm._v(" "),_c('AddressBar',{attrs:{"url":_vm.displayUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }